import { render, staticRenderFns } from "./SignInPage.vue?vue&type=template&id=b931348a&scoped=true"
import script from "./SignInPage.vue?vue&type=script&lang=js"
export * from "./SignInPage.vue?vue&type=script&lang=js"
import style0 from "./SignInPage.vue?vue&type=style&index=0&id=b931348a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b931348a",
  null
  
)

export default component.exports